import { mediator } from '@ioc/mediator'
import { RequestData } from 'mediatr-ts'

import { MetricType } from '@domain/metrics'

export class TrackMetricCommand extends RequestData {
  constructor(
    public type: MetricType,
    public action: string,
    public properties?: Record<string, unknown>,
  ) {
    super()
  }
}

export const track = (type: MetricType, action: string, properties?: Record<string, unknown>) =>
  mediator.send(new TrackMetricCommand(type, action, properties))
